/**
 * # Lounge Search Results
 *
 *
 */
import { dateToWeekIndex } from '@yiluhub/ui-utilities';
import { SearchItem } from '@yiluhub/yilu-amp-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { SearchResultCard, SearchResultNotFound } from 'components';

import { LoungeSearchResultCard } from '../LoungeSearchResultCard';
import { useLoungeSearchResultsLoader } from './hooks';
import { LoungeSearchResultsProps } from './types';

const PLACEHOLDER_COUNT = 3;

export const LoungeSearchResults: React.FC<LoungeSearchResultsProps> = ({
  searchParams,
  onSearchResults,
  onSearchResultClick,
  onError,
  onLoading,
}) => {
  const { t } = useTranslation();
  const { isLoading, pageNumber, totalPages, setLastElement, searchResults } =
    useLoungeSearchResultsLoader({
      searchParams,
      onSearchResults,
      onError,
      onLoading,
    });
  const searchedDateOfWeek = dateToWeekIndex(searchParams.entryDate);

  const travellersCount =
    searchParams.adults + (searchParams.children || 0) + (searchParams.infants || 0);

  return (
    <>
      {!isLoading && !searchResults.length && (
        <SearchResultNotFound
          title={t('Lounges no results found')}
          message={t('Lounges no results found message')}
        />
      )}
      {isLoading &&
        pageNumber === 0 &&
        Array(PLACEHOLDER_COUNT)
          .fill(0)
          .map((_, index) => <SearchResultCard asPlaceholder key={index} />)}
      <section>
        {searchResults.map((searchResult: SearchItem, index: number) => {
          const isLastElement =
            index === searchResults.length - 1 && !isLoading && pageNumber < totalPages - 1;
          return (
            <LoungeSearchResultCard
              cardRef={isLastElement ? setLastElement : undefined}
              key={searchResult.id}
              data={searchResult}
              searchedDateOfWeek={searchedDateOfWeek}
              searchedTravellersCount={travellersCount}
              onClick={onSearchResultClick}
            />
          );
        })}
        {isLoading && pageNumber !== 0 && <SearchResultCard asPlaceholder />}
      </section>
    </>
  );
};
